import { ComponentBrandingBase } from '../components'
import { BrandingGuideDelegate } from '../types'
import { AppHeaderBrandingSpec } from './types'

export default class AppHeaderBranding extends ComponentBrandingBase<AppHeaderBrandingSpec> {

  constructor(
    delegate: BrandingGuideDelegate,
    parent: AppHeaderBranding | null,
  ) {
    super(delegate, parent, {
      background: 'alt',
      shape:      'rectangle',
      border:     {
        type: 'solid',
        width: 1,
        offset: 0,
        position: 'inside',
        color:    delegate.rootGuide.colors.border.dimmer,
      },
      depth:      0,

      title:    null,
      subtitle: null,
    })

    this.variant('ios')
    this.variant('android')
  }

  public resolveTitle(flags: Record<string, boolean> = {}) {
    return this.resolve('title', flags)
  }

  public resolveSubtitle(flags: Record<string, boolean> = {}) {
    return this.resolve('subtitle', flags)
  }

  public previewSize = {
    width:  375,
    height: 64,
  }

}